import { all, fork } from 'redux-saga/effects';
import usersSaga from '../modules/UserManagement/User_list/redux/sagas/users.saga';
import userAuthRootSaga from '../modules/App/redux/sagas/auth_root.saga';
import leadsRootSaga from '../modules/Leads/Lead_profile/redux/sagas/leads_root.saga';
import managerLeadsRootSaga from '../modules/Leads/Manager_special/redux/sagas/manager_leads_root.saga';
import userInfoSaga from '../modules/App/redux/sagas/user_info.saga';
import addUserSaga from '../modules/UserManagement/User_create/redux/sagas/add_user.saga';
import getUserProfileSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_sagas/get_user_profile.saga';
import updateUserSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_sagas/change_user_profile.saga';
import changeUserStatusSaga from '../modules/UserManagement/User_list/redux/sagas/change_user_status.saga';
import userPhonesRootSaga from '../modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/phones_root.saga';
import userEmailsRootSaga from '../modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/emails_root.saga';
import changeUserAvatarSaga from '../modules/UserManagement/User_profile/redux/sagas/change_user_avatar.saga';
import userAddressRootSaga from '../modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/addresses_root.saga';
import changeUserPasswordSaga from '../modules/UserManagement/User_profile/redux/sagas/change_user_password.saga';
import transportUserSaga from '../modules/UserManagement/User_profile/redux/sagas/transport_user.saga';

import modelsSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/get_bike_models.saga';
import bikesOverviewSaga from '../modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model_overview.saga';
import bikeModelSaga from '../modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model.saga';
import createBikeModelSaga from '../modules/PlatformManagement/Bike_model_create/redux/sagas/create_bike_model.saga';
import modelVariantsSaga from '../modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model_variants.saga';
import changeBikeModelSaga from '../modules/PlatformManagement/Bike_model_update/redux/sagas/change_bike_model.saga';
import changeBikeModelListSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/change_bike_model_list.saga';
import createBikeModelVariantsSaga from '../modules/PlatformManagement/Bike_variant_create/redux/sagas/create_bike_model_variants.saga';
import changeBikeModelVariantsSaga from '../modules/PlatformManagement/Bike_model_update/redux/sagas/change_bike_model_variants.saga';
import searchByBrandSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_by_brand.saga';
import searchBikeModelSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_model.saga';
import getGroupsListSaga from '../modules/UserManagement/User_group/redux/sagas/get_groups_list.saga';
import addGroupSaga from '../modules/UserManagement/User_group_create/redux/sagas/add_group.saga';
import getUsersQuantitySaga from '../modules/UserManagement/User_group/redux/sagas/get_users_quantity.saga';

import getPriceOMWebJobsSaga from '../modules/PlatformManagement/Price-o-matic/redux/sagas/get_web_jobs.saga';
import getPriceOMSaga from '../modules/PlatformManagement/Price-o-matic_update/redux/sagas/get_priceom_config.saga';
import changePriceOMSaga from '../modules/PlatformManagement/Price-o-matic_update/redux/sagas/change_priceom_config.saga';

import getLeadOMSaga from '../modules/PlatformManagement/Lead-o-matic_update/redux/sagas/get_leadomatic_config.saga';
import changeLeadOMSaga from '../modules/PlatformManagement/Lead-o-matic_update/redux/sagas/change_leadomatic_config.saga';
import getLeadOMWebJobsSaga from '../modules/PlatformManagement/Lead-o-matic/redux/sagas/get_web_jobs.saga';
import editLocationCriteriaSaga from '../modules/PlatformManagement/Lead-o-matic_location_update/redux/sagas/edit_location_criteria.saga';

import checkLastRouteSaga from '../modules/App/redux/sagas/check_last_route.saga';
import checkPermissionForViewSaga from '../modules/App/redux/sagas/check_permissions_for_view.saga';
import addLocationCriteriaSaga from '../modules/PlatformManagement/Lead-o-matic_location_create/redux/sagas/add_location_criteria.saga';
import searchByRegSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_by_reg.saga';
import searchByVariantSaga from '../modules/Leads/Lead_profile/redux/sagas/search_by_variant.saga';
import searchLeadCountySaga from '../modules/Leads/Lead_create/redux/sagas/search_lead_county.saga';
import getBikeModelsSaga from '../modules/Leads/Lead_create/redux/sagas/get_bike_models.saga';
import findBikeSaga from '../modules/Leads/Lead_create/redux/sagas/find_bike.saga';
import getBikeCatalogsFromExperianSaga from '../modules/Leads/Lead_create/redux/sagas/getBikeCatalogsFromExperian.saga';
import getBikeVariantsSaga from '../modules/Leads/Lead_create/redux/sagas/get_bike_variants.saga';
import getBikeForPartExSaga from '../modules/Leads/Lead_create/redux/sagas/get_bikes_for_part_ex.saga';
import createLeadSaga from '../modules/Leads/Lead_create/redux/sagas/create_lead.saga';
import getCreateLeadcatalogsSaga from '../modules/Leads/Lead_create/redux/sagas/getCatalogs.saga';

import LeadCreateCountyCreateSaga from '../modules/Leads/Lead_create/redux/sagas/create_new_county.saga';

import userProfileGroupsReadSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_read.saga';
import userProfileGroupsAddSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_add.saga';
import userProfileGroupsRemoveSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_remove.saga';
import changeUserDivisionsSaga from '../modules/UserManagement/User_profile/redux/sagas/user_profile_divisions_saga/changeUserDivisions.saga';
import createOrderTransportSaga from '../modules/Leads/Lead_profile/redux/sagas/create_order.saga';
import inviteUserDataSaga from '../modules/UserManagement/User_create/redux/sagas/invite_user_data.saga';
import leadApprovalGetLeadsSaga from '../modules/Leads/Lead_approval/redux/sagas/lead_approval_get_leads.saga';

import getModulesStructureSaga from '../modules/UserManagement/User_group_update/redux/sagas/get_modules_structure.saga';
import checkPermissionForFieldSaga from '../modules/App/redux/sagas/check_permission_for_field.saga';

// User Group Update Sagas
import userGroupUpdateRootSaga from '../modules/UserManagement/User_group_update/redux/sagas/root.saga';
import getRefBikeModelsSaga from '../modules/Leads/Lead_profile/redux/sagas/get_ref_bike_model.saga';
import getAffiliatesSaga from '../modules/PlatformManagement/Manage_affiliates/redux/sagas/get_affiliates.saga';
import createAffiliateSaga from '../modules/PlatformManagement/Manage_affiliates_create/redux/sagas/create_affiliate.saga';
import updateAffiliatesSaga from '../modules/PlatformManagement/Manage_affiliates_update/redux/sagas/update_affiliate.saga';
import searchBikeSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_bike.saga';
import filterSearchSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/filter_search.saga';
import searchByHCSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_by_hot_cold.saga';
import searchBikesSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_bikes.saga';
import searchBikeBrandSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_brand.saga';
import searchBikeModelsSaga from '../modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_models.saga';
import generateUserAPITokenSaga from '../modules/UserManagement/User_profile/redux/sagas/generate_user_api_token.saga';

export default function* rootSaga() {
    yield all([
        searchByHCSaga(),
        searchBikeSaga(),
        searchBikesSaga(),
        searchBikeBrandSaga(),
        searchBikeModelsSaga(),
        filterSearchSaga(),
        updateAffiliatesSaga(),
        createAffiliateSaga(),
        getAffiliatesSaga(),
        getRefBikeModelsSaga(),
        getModulesStructureSaga(),
        usersSaga(),
        fork(userAuthRootSaga),
        fork(userInfoSaga),
        fork(transportUserSaga),
        userGroupUpdateRootSaga(),
        checkPermissionForFieldSaga(),
        createOrderTransportSaga(),
        checkPermissionForViewSaga(),
        inviteUserDataSaga(),
        userProfileGroupsAddSaga(),
        userProfileGroupsRemoveSaga(),
        changeUserDivisionsSaga(),
        leadsRootSaga(),
        managerLeadsRootSaga(),
        modelsSaga(),
        addUserSaga(),
        getUserProfileSaga(),
        updateUserSaga(),
        changeUserStatusSaga(),
        changeUserAvatarSaga(),
        changeUserPasswordSaga(),
        userPhonesRootSaga(),
        userEmailsRootSaga(),
        userAddressRootSaga(),
        bikesOverviewSaga(),
        bikeModelSaga(),
        modelVariantsSaga(),
        createBikeModelSaga(),
        changeBikeModelSaga(),
        changeBikeModelListSaga(),
        createBikeModelVariantsSaga(),
        changeBikeModelVariantsSaga(),
        searchLeadCountySaga(),
        searchByBrandSaga(),
        searchByRegSaga(),
        searchBikeModelSaga(),
        getGroupsListSaga(),
        addGroupSaga(),
        getPriceOMWebJobsSaga(),
        getPriceOMSaga(),
        changePriceOMSaga(),
        getUsersQuantitySaga(),
        getLeadOMSaga(),
        changeLeadOMSaga(),
        getLeadOMWebJobsSaga(),
        editLocationCriteriaSaga(),
        checkLastRouteSaga(),
        addLocationCriteriaSaga(),
        searchByVariantSaga(),
        getBikeModelsSaga(),
        getBikeVariantsSaga(),
        getBikeForPartExSaga(),
        getCreateLeadcatalogsSaga(),
        findBikeSaga(),
        getBikeCatalogsFromExperianSaga(),
        createLeadSaga(),
        LeadCreateCountyCreateSaga(),
        userProfileGroupsReadSaga(),
        leadApprovalGetLeadsSaga(),
        generateUserAPITokenSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/root.saga.js